export const DEFAULT_DROPBOX_ROOT = '/Valuation';

export const DROPBOX_ROOT_OPTIONS = [DEFAULT_DROPBOX_ROOT, '/Valuation - Israel'];

// Subfolders under a valuation folder that hold the final model and report files.
export const MODEL_SUBFOLDER = 'Model';
export const REPORT_SUBFOLDER = 'Report';

export const DROPBOX_FOLDER_STATUS = {
  IDLE: 'idle',
  SEARCHING: 'searching',
  EXISTS: 'exists',
  MATCHES: 'matches',
  NOT_FOUND: 'not_found',
  CREATING: 'creating',
  CREATED: 'created',
  SYNCING: 'syncing',
  ERROR: 'error',
} as const;
